var map = {
	"./button_xingau_1.png": 99684,
	"./button_xingau_1_kochon.png": 44961,
	"./button_xingau_2.png": 37983,
	"./button_xingau_2_kochon.png": 54320,
	"./button_xingau_3.png": 58006,
	"./button_xingau_3_kochon.png": 6479
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77466;